import React from 'react';
import PropTypes from 'prop-types';

const alertTypes = {
  success: 'alert-success',
  error: 'alert-error',
  info: 'alert-info',
  warning: 'alert-warning',
};

function AlertBar({ alertType, children, errorTitle }) {
  const alertClass = alertTypes[alertType];

  return (
    <div
      role='alert'
      className={`alert mb-7 rounded text-lg [&>div>p]:mb-0 [&>div]:space-y-7  [&_a]:border-base-content [&_a]:text-base-content ${alertClass}`}
    >
      {errorTitle && <strong>{errorTitle}</strong>}
      {children}
    </div>
  );
}

AlertBar.propTypes = {
  alertType: PropTypes.oneOf(Object.keys(alertTypes)),
  children: PropTypes.node.isRequired,
  errorTitle: PropTypes.string,
};

export default AlertBar;
